exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".DeviceList__DeviceList__iPcQl {\n  margin-bottom: 24px; }\n", ""]);

// exports
exports.locals = {
	"DeviceList": "DeviceList__DeviceList__iPcQl"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/circleci/project/src/styles"]}!./src/app/nest/components/DeviceList/DeviceList.scss
// module id = 393
// module chunks = 0